module.exports = __webpack_public_path__ + "static/payal_before-7f4d04baa491a81b5426871d777c0b1e.png";